import { Box, Typography } from "@material-ui/core";
import React from "react";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";

const Footer = (props) => {
  const { t, i18n } = useTranslation();
  const { currentWeekDate, events } = props;
  console.log("this is footerEvents ", events);
  let arr = Array(7).fill(0);
  arr.fill(0);
  // const [arr, setArr] = useState(Array(7).fill(0));
  //console.log("this is footer ", moment(currentWeekDate).format("DD"));
  //console.log("this is footer events ", events);
  //(events.length > 0 && console.log("this is title ", events[0].title));
  const weekArray = [];
  for (let i = 0; i < 7; i++) {
    weekArray.push(moment(currentWeekDate).add(i, 'day'));
  }

  const getTotalHoursForDay = (weekDay) => {
    let totalDurationMeal = 0;
    let totalDurationActivities = 0;
    let totalDuration = 0;
        
    for (let i = 0; i < events.length; i++) {
      if (moment(events[i].startStr).format("DDMM") == weekDay.format("DDMM")
        && moment(events[i].endStr).format("DDMM") == weekDay.format("DDMM")) {
        if (events[i].title?.toLowerCase() != 'meal') 
        {
          
          const diffDuration = moment(events[i].endStr.substr(0, 16)).diff(moment(events[i].startStr.substr(0, 16)));          
          if(!isNaN(diffDuration))
          {            
             let  durationInHours = moment.duration(diffDuration).asHours();             
            let durationInFixed  = parseFloat(durationInHours.toFixed(2));            
            totalDurationActivities = totalDurationActivities + durationInFixed;
            
            }
        }
        else {
          
          const diffMeal = moment(events[i].endStr.substr(0, 16)).diff(moment(events[i].startStr.substr(0, 16)));
          if(!isNaN(diffMeal)){
          let durationInHoursMeal = moment.duration(diffMeal).asHours();
          let durationInFixedMeal  = parseFloat(durationInHoursMeal.toFixed(2));
          totalDurationMeal = totalDurationMeal + durationInFixedMeal;
          
          }
        }
      }

      if (moment(events[i].startStr).format("DDMM") == weekDay.format("DDMM")
        && moment(events[i].endStr).format("DDMM") != weekDay.format("DDMM")) {
        if (events[i].title != 'Meal') {
          const diffDuration = moment(events[i].startStr.substr(0, 16)).endOf('day').diff(moment(events[i].startStr.substr(0, 16)));
          if(!isNaN(diffDuration)){
          let durationInHours   = moment.duration(diffDuration).asHours();
          let durationFixed  = parseFloat(durationInHours.toFixed(2));
          totalDurationActivities = totalDurationActivities + durationFixed;
          
          }
        }
        else {
          const diffDurationMeal  = moment(events[i].startStr.substr(0, 16)).endOf('day').diff(moment(events[i].startStr.substr(0, 16)));
          if(!isNaN(diffDurationMeal)){
          let durationInHoursMeal = moment.duration(diffDurationMeal).asHours();
          let durationMealFixed  = parseFloat(durationInHoursMeal.toFixed(2));
          totalDurationMeal = totalDurationMeal + durationMealFixed;
          
          }
        }
      }

      if (moment(events[i].startStr).format("DDMM") != weekDay.format("DDMM")
        && moment(events[i].endStr).format("DDMM") == weekDay.format("DDMM")) {
        if (events[i].title?.toLowerCase() != 'meal') {
          const diffDuration  = moment(events[i].endStr.substr(0, 16)).diff(moment(events[i].endStr.substr(0, 16)).startOf('day'));
          if(!isNaN(diffDuration)){
          let durationInHours = moment.duration(diffDuration).asHours();
          let durationFixed = parseFloat(durationInHours.toFixed(2));
          totalDurationActivities = totalDurationActivities + durationFixed;
          
          }
        }
        else {
          const diffDurationMeal = moment(events[i].endStr.substr(0, 16)).diff(moment(events[i].endStr.substr(0, 16)).startOf('day'));
          if(!isNaN(diffDurationMeal)){
          let durationInHoursMeal = moment.duration(diffDurationMeal).asHours();
          let durationMealFixed  = parseFloat(durationInHoursMeal.toFixed(2));
          totalDurationMeal = totalDurationMeal + durationMealFixed;
          
          }
        }
      }
    }


    if (totalDurationActivities) {
      let activityDuration = totalDurationActivities;
      if (isNaN(activityDuration)) {
        totalDurationActivities = "0";
      }
      else {
        totalDurationActivities = activityDuration.toFixed(2);
      }
    }
    else {
      totalDurationActivities = "0";
    }

    if (totalDurationMeal) {
      let mealDuration = totalDurationMeal;
      if (isNaN(mealDuration)) {
        totalDurationMeal = "0";
      }
      else {
        totalDurationMeal = mealDuration.toFixed(2);
      }
    }
    else {
      totalDurationMeal = "0";
    }
    totalDuration = parseFloat(totalDurationActivities) + parseFloat(totalDurationMeal);
    totalDuration = parseFloat(totalDuration).toFixed(2);
    if (totalDuration == 0) {
      totalDuration = 0;
    }
    return { totalDurationActivities, totalDurationMeal, totalDuration };
  }

  const populateTableArray = () => {
    let tempArray = [];
    let totalHours;
    for (let i = 0; i < 7; i++) {
      totalHours = getTotalHoursForDay(weekArray[i]);
      tempArray.push(totalHours);
    }
    return tempArray;
  }

  //console.log("this is populateArray ", populateTableArray());
  arr = populateTableArray();

  return (
    <Box
      component="table"
      style={{
        tableLayout: "fixed",
        width: `calc(100% - 24px)`,
        borderStyle: "hidden",
      }}
    >
      <colgroup>
        <col style={{ width: "38px" }} />
      </colgroup>
      <tbody>
        <tr>
          <td>
            <Typography style={{ fontSize: "10px", color: "transparent" }}>
              na se
            </Typography>
          </td>
          {arr.map((e, i) => (
            <td
              key={i}
              style={{
                borderStyle: "hidden",
                padding: 8,
              }}
            >
              <Typography variant="subtitle1">
                <span style={{ fontWeight: "550", color: "#58595B" }}> {properCase(t("other.activity"))} : </span>
                <span style={{ fontWeight: "500", color: "#58595B" }}>{`${e.totalDurationActivities}`}</span>
              </Typography>
              <Typography variant="subtitle1" style={{ fontWeight: "550", color: "#58595B" }}>
                <span style={{ fontWeight: "550", color: "#58595B" }}>{properCase(t("other.tlMeal"))} : </span>
                <span style={{ fontWeight: "500", color: "#58595B" }}>{`${e.totalDurationMeal}`}</span>
              </Typography>
              <Typography variant="subtitle1" style={{ fontWeight: "550", color: "#58595B" }}>
                <span style={{ fontWeight: "550", color: "#58595B" }}>{properCase(t("other.dscLblTotal"))} : </span>
                <span style={{ fontWeight: "500", color: "#58595B" }}>{`${e.totalDuration}`}</span>
              </Typography>
            </td>
          ))}
        </tr>
      </tbody>
    </Box>
  );
};

export default Footer;
